var map = {
	"./Followup.js": "./src/api/Followup.js",
	"./Sales.js": "./src/api/Sales.js",
	"./SalesP.js": "./src/api/SalesP.js",
	"./aftersale.js": "./src/api/aftersale.js",
	"./allExport.js": "./src/api/allExport.js",
	"./ban.js": "./src/api/ban.js",
	"./biexport.js": "./src/api/biexport.js",
	"./borrowMoney.js": "./src/api/borrowMoney.js",
	"./category.js": "./src/api/category.js",
	"./classification.js": "./src/api/classification.js",
	"./contract.js": "./src/api/contract.js",
	"./copyDelivery.js": "./src/api/copyDelivery.js",
	"./customPit.js": "./src/api/customPit.js",
	"./customer.js": "./src/api/customer.js",
	"./decoration.js": "./src/api/decoration.js",
	"./delivery.js": "./src/api/delivery.js",
	"./examine.js": "./src/api/examine.js",
	"./fr.js": "./src/api/fr.js",
	"./fund.js": "./src/api/fund.js",
	"./fz.js": "./src/api/fz.js",
	"./general.js": "./src/api/general.js",
	"./http.js": "./src/api/http.js",
	"./index.js": "./src/api/index.js",
	"./insurance.js": "./src/api/insurance.js",
	"./invoice.js": "./src/api/invoice.js",
	"./login.js": "./src/api/login.js",
	"./logistics.js": "./src/api/logistics.js",
	"./logisticscity.js": "./src/api/logisticscity.js",
	"./member.js": "./src/api/member.js",
	"./payment.js": "./src/api/payment.js",
	"./product.js": "./src/api/product.js",
	"./ranking.js": "./src/api/ranking.js",
	"./ren.js": "./src/api/ren.js",
	"./set.js": "./src/api/set.js",
	"./share.js": "./src/api/share.js",
	"./tdc.js": "./src/api/tdc.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/api sync \\.js$";